var cov_2b14ihjwul = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/directives/accumulateChartSyncfusion.js',
      hash = '1586270166bd9c4d12b134cc33ab7f165914244a',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/directives/accumulateChartSyncfusion.js',
    statementMap: {
      '0': {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 152,
          column: 3
        }
      },
      '1': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 151,
          column: 4
        }
      },
      '2': {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 35,
          column: 7
        }
      },
      '3': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 25
        }
      },
      '4': {
        start: {
          line: 46,
          column: 21
        },
        end: {
          line: 102,
          column: 7
        }
      },
      '5': {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 58,
          column: 9
        }
      },
      '6': {
        start: {
          line: 49,
          column: 10
        },
        end: {
          line: 49,
          column: 36
        }
      },
      '7': {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 63,
          column: 9
        }
      },
      '8': {
        start: {
          line: 62,
          column: 10
        },
        end: {
          line: 62,
          column: 17
        }
      },
      '9': {
        start: {
          line: 67,
          column: 25
        },
        end: {
          line: 78,
          column: 9
        }
      },
      '10': {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 95,
          column: 9
        }
      },
      '11': {
        start: {
          line: 83,
          column: 10
        },
        end: {
          line: 94,
          column: 11
        }
      },
      '12': {
        start: {
          line: 84,
          column: 24
        },
        end: {
          line: 84,
          column: 25
        }
      },
      '13': {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 89,
          column: 13
        }
      },
      '14': {
        start: {
          line: 87,
          column: 14
        },
        end: {
          line: 87,
          column: 51
        }
      },
      '15': {
        start: {
          line: 88,
          column: 14
        },
        end: {
          line: 88,
          column: 22
        }
      },
      '16': {
        start: {
          line: 91,
          column: 12
        },
        end: {
          line: 93,
          column: 13
        }
      },
      '17': {
        start: {
          line: 92,
          column: 14
        },
        end: {
          line: 92,
          column: 57
        }
      },
      '18': {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 98,
          column: 68
        }
      },
      '19': {
        start: {
          line: 101,
          column: 8
        },
        end: {
          line: 101,
          column: 41
        }
      },
      '20': {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 108,
          column: 9
        }
      },
      '21': {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 28
        }
      },
      '22': {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 17
        }
      },
      '23': {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 15
        }
      },
      '24': {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 140,
          column: 9
        }
      },
      '25': {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 115,
          column: 28
        }
      },
      '26': {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 120,
          column: 9
        }
      },
      '27': {
        start: {
          line: 119,
          column: 10
        },
        end: {
          line: 119,
          column: 17
        }
      },
      '28': {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 123,
          column: 9
        }
      },
      '29': {
        start: {
          line: 122,
          column: 10
        },
        end: {
          line: 122,
          column: 17
        }
      },
      '30': {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 70
        }
      },
      '31': {
        start: {
          line: 129,
          column: 8
        },
        end: {
          line: 139,
          column: 17
        }
      },
      '32': {
        start: {
          line: 131,
          column: 10
        },
        end: {
          line: 131,
          column: 92
        }
      },
      '33': {
        start: {
          line: 134,
          column: 10
        },
        end: {
          line: 138,
          column: 19
        }
      },
      '34': {
        start: {
          line: 135,
          column: 12
        },
        end: {
          line: 135,
          column: 57
        }
      },
      '35': {
        start: {
          line: 136,
          column: 12
        },
        end: {
          line: 136,
          column: 29
        }
      },
      '36': {
        start: {
          line: 137,
          column: 12
        },
        end: {
          line: 137,
          column: 44
        }
      },
      '37': {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 149,
          column: 7
        }
      },
      '38': {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 148,
          column: 11
        }
      },
      '39': {
        start: {
          line: 145,
          column: 10
        },
        end: {
          line: 145,
          column: 33
        }
      },
      '40': {
        start: {
          line: 147,
          column: 10
        },
        end: {
          line: 147,
          column: 67
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 22,
            column: 61
          },
          end: {
            line: 22,
            column: 62
          }
        },
        loc: {
          start: {
            line: 22,
            column: 73
          },
          end: {
            line: 152,
            column: 1
          }
        },
        line: 22
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 46,
            column: 21
          },
          end: {
            line: 46,
            column: 22
          }
        },
        loc: {
          start: {
            line: 46,
            column: 33
          },
          end: {
            line: 102,
            column: 7
          }
        },
        line: 46
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 104,
            column: 19
          },
          end: {
            line: 104,
            column: 20
          }
        },
        loc: {
          start: {
            line: 104,
            column: 28
          },
          end: {
            line: 106,
            column: 7
          }
        },
        line: 104
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 106,
            column: 9
          },
          end: {
            line: 106,
            column: 10
          }
        },
        loc: {
          start: {
            line: 106,
            column: 21
          },
          end: {
            line: 108,
            column: 7
          }
        },
        line: 106
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 114,
            column: 19
          },
          end: {
            line: 114,
            column: 20
          }
        },
        loc: {
          start: {
            line: 114,
            column: 28
          },
          end: {
            line: 116,
            column: 7
          }
        },
        line: 114
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 116,
            column: 9
          },
          end: {
            line: 116,
            column: 10
          }
        },
        loc: {
          start: {
            line: 116,
            column: 21
          },
          end: {
            line: 140,
            column: 7
          }
        },
        line: 116
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 129,
            column: 17
          },
          end: {
            line: 129,
            column: 18
          }
        },
        loc: {
          start: {
            line: 129,
            column: 23
          },
          end: {
            line: 139,
            column: 9
          }
        },
        line: 129
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 134,
            column: 19
          },
          end: {
            line: 134,
            column: 20
          }
        },
        loc: {
          start: {
            line: 134,
            column: 25
          },
          end: {
            line: 138,
            column: 11
          }
        },
        line: 134
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 144,
            column: 36
          },
          end: {
            line: 144,
            column: 37
          }
        },
        loc: {
          start: {
            line: 144,
            column: 45
          },
          end: {
            line: 148,
            column: 9
          }
        },
        line: 144
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        }],
        line: 33
      },
      '1': {
        loc: {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }, {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }],
        line: 48
      },
      '2': {
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 63,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 63,
            column: 9
          }
        }, {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 63,
            column: 9
          }
        }],
        line: 61
      },
      '3': {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 95,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 95,
            column: 9
          }
        }, {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 95,
            column: 9
          }
        }],
        line: 82
      },
      '4': {
        loc: {
          start: {
            line: 91,
            column: 12
          },
          end: {
            line: 93,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 91,
            column: 12
          },
          end: {
            line: 93,
            column: 13
          }
        }, {
          start: {
            line: 91,
            column: 12
          },
          end: {
            line: 93,
            column: 13
          }
        }],
        line: 91
      },
      '5': {
        loc: {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        }, {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        }],
        line: 118
      },
      '6': {
        loc: {
          start: {
            line: 118,
            column: 14
          },
          end: {
            line: 118,
            column: 44
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 118,
            column: 14
          },
          end: {
            line: 118,
            column: 27
          }
        }, {
          start: {
            line: 118,
            column: 31
          },
          end: {
            line: 118,
            column: 44
          }
        }],
        line: 118
      },
      '7': {
        loc: {
          start: {
            line: 121,
            column: 8
          },
          end: {
            line: 123,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 121,
            column: 8
          },
          end: {
            line: 123,
            column: 9
          }
        }, {
          start: {
            line: 121,
            column: 8
          },
          end: {
            line: 123,
            column: 9
          }
        }],
        line: 121
      },
      '8': {
        loc: {
          start: {
            line: 126,
            column: 28
          },
          end: {
            line: 126,
            column: 69
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 126,
            column: 28
          },
          end: {
            line: 126,
            column: 46
          }
        }, {
          start: {
            line: 126,
            column: 50
          },
          end: {
            line: 126,
            column: 69
          }
        }],
        line: 126
      },
      '9': {
        loc: {
          start: {
            line: 131,
            column: 29
          },
          end: {
            line: 131,
            column: 58
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 131,
            column: 45
          },
          end: {
            line: 131,
            column: 50
          }
        }, {
          start: {
            line: 131,
            column: 53
          },
          end: {
            line: 131,
            column: 58
          }
        }],
        line: 131
      },
      '10': {
        loc: {
          start: {
            line: 131,
            column: 60
          },
          end: {
            line: 131,
            column: 90
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 131,
            column: 60
          },
          end: {
            line: 131,
            column: 79
          }
        }, {
          start: {
            line: 131,
            column: 83
          },
          end: {
            line: 131,
            column: 90
          }
        }],
        line: 131
      },
      '11': {
        loc: {
          start: {
            line: 135,
            column: 32
          },
          end: {
            line: 135,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 135,
            column: 32
          },
          end: {
            line: 135,
            column: 50
          }
        }, {
          start: {
            line: 135,
            column: 54
          },
          end: {
            line: 135,
            column: 56
          }
        }],
        line: 135
      },
      '12': {
        loc: {
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 149,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 149,
            column: 7
          }
        }, {
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 149,
            column: 7
          }
        }],
        line: 143
      },
      '13': {
        loc: {
          start: {
            line: 147,
            column: 36
          },
          end: {
            line: 147,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 147,
            column: 36
          },
          end: {
            line: 147,
            column: 54
          }
        }, {
          start: {
            line: 147,
            column: 58
          },
          end: {
            line: 147,
            column: 65
          }
        }],
        line: 147
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2b14ihjwul.s[0]++;

angular.module('app').directive('accumulateChartSyncfusion', function ($timeout) {
  cov_2b14ihjwul.f[0]++;
  cov_2b14ihjwul.s[1]++;

  return {
    restrict: 'A',
    scope: {
      params: '=',
      export: '=?',
      exportWithRightClick: '=?' },
    template: '<div></div>',
    link: function link(scope, element, attrs) {
      cov_2b14ihjwul.s[2]++;

      if (!scope.export) {
        cov_2b14ihjwul.b[0][0]++;
        cov_2b14ihjwul.s[3]++;

        scope.export = 0;
      } else {
        cov_2b14ihjwul.b[0][1]++;
      }

      cov_2b14ihjwul.s[4]++;

      var render = function render() {
        cov_2b14ihjwul.f[1]++;
        cov_2b14ihjwul.s[5]++;

        if (scope.chart) {
          cov_2b14ihjwul.b[1][0]++;
          cov_2b14ihjwul.s[6]++;

          element[0].innerHTML = '';
        } else {
          cov_2b14ihjwul.b[1][1]++;
        }

        cov_2b14ihjwul.s[7]++;

        if (!scope.params) {
          cov_2b14ihjwul.b[2][0]++;
          cov_2b14ihjwul.s[8]++;

          return;
        } else {
          cov_2b14ihjwul.b[2][1]++;
        }

        var palettes = (cov_2b14ihjwul.s[9]++, ['#BAF171', '#C4EAF6', '#E9B1FF', '#F49C94', '#FCF086', '#58D740', '#7DDAF8', '#CA6FEE', '#FE855F', '#F9E850', '#1EB799', '#29DAE9', '#B145F4', '#CD5145', '#EDDA2F', '#2EAB77', '#20C9B3', '#6F43EA', '#EB5757', '#EDC32F', '#66AF45', '#33ACED', '#562EBB', '#DA4A2B', '#D39F17', '#78A73D', '#208AC9', '#792AF9', '#F35634', '#B8953B', '#A5B212', '#3160BC', '#651E91', '#AE534B', '#F38434', '#12A5B2', '#5C83E7', '#911E71', '#7E3737', '#D36617', '#2F7980', '#035C88', '#401C5B', '#5E4138', '#B66225', '#0E3E53', '#093B69', '#240E35', '#3E2B11', '#B24712']);

        cov_2b14ihjwul.s[10]++;

        if (scope.params.series) {
          cov_2b14ihjwul.b[3][0]++;
          cov_2b14ihjwul.s[11]++;

          for (var _iterator = scope.params.series, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var series = _ref;

            var index = (cov_2b14ihjwul.s[12]++, 0);
            cov_2b14ihjwul.s[13]++;
            for (var _iterator2 = series.dataSource, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
              var _ref2;

              if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
              } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
              }

              var item = _ref2;
              cov_2b14ihjwul.s[14]++;

              item.deltaAppColor = palettes[index];
              cov_2b14ihjwul.s[15]++;
              index++;
            }
            cov_2b14ihjwul.s[16]++;

            if (!series.pointColorMapping) {
              cov_2b14ihjwul.b[4][0]++;
              cov_2b14ihjwul.s[17]++;

              series.pointColorMapping = 'deltaAppColor';
            } else {
              cov_2b14ihjwul.b[4][1]++;
            }
          }
        } else {
          cov_2b14ihjwul.b[3][1]++;
        }

        cov_2b14ihjwul.s[18]++;

        scope.chart = new ej.charts.AccumulationChart(scope.params);

        cov_2b14ihjwul.s[19]++;

        scope.chart.appendTo(element[0]);
      };
      cov_2b14ihjwul.s[20]++;

      scope.$watch(function (scope) {
        cov_2b14ihjwul.f[2]++;
        cov_2b14ihjwul.s[21]++;

        return scope.params;
      }, function (newValue) {
        cov_2b14ihjwul.f[3]++;
        cov_2b14ihjwul.s[22]++;

        render();
      });

      cov_2b14ihjwul.s[23]++;

      render();

      cov_2b14ihjwul.s[24]++;

      scope.$watch(function (scope) {
        cov_2b14ihjwul.f[4]++;
        cov_2b14ihjwul.s[25]++;

        return scope.export;
      }, function (newValue) {
        cov_2b14ihjwul.f[5]++;
        cov_2b14ihjwul.s[26]++;

        if (!((cov_2b14ihjwul.b[6][0]++, newValue == 1) || (cov_2b14ihjwul.b[6][1]++, newValue == 2))) {
          cov_2b14ihjwul.b[5][0]++;
          cov_2b14ihjwul.s[27]++;

          return;
        } else {
          cov_2b14ihjwul.b[5][1]++;
        }
        cov_2b14ihjwul.s[28]++;
        if (!scope.params) {
          cov_2b14ihjwul.b[7][0]++;
          cov_2b14ihjwul.s[29]++;

          return;
        } else {
          cov_2b14ihjwul.b[7][1]++;
        }

        cov_2b14ihjwul.s[30]++;

        scope.chart.title = (cov_2b14ihjwul.b[8][0]++, scope.params.title) || (cov_2b14ihjwul.b[8][1]++, scope.params.title_);

        cov_2b14ihjwul.s[31]++;

        $timeout(function () {
          cov_2b14ihjwul.f[6]++;
          cov_2b14ihjwul.s[32]++;

          scope.chart.export(newValue == 1 ? (cov_2b14ihjwul.b[9][0]++, 'PNG') : (cov_2b14ihjwul.b[9][1]++, 'PDF'), (cov_2b14ihjwul.b[10][0]++, scope.params.title_) || (cov_2b14ihjwul.b[10][1]++, 'chart'));

          cov_2b14ihjwul.s[33]++;

          $timeout(function () {
            cov_2b14ihjwul.f[7]++;
            cov_2b14ihjwul.s[34]++;

            scope.chart.title = (cov_2b14ihjwul.b[11][0]++, scope.params.title) || (cov_2b14ihjwul.b[11][1]++, '');
            cov_2b14ihjwul.s[35]++;
            scope.export = 0;cov_2b14ihjwul.s[36]++;

            scope.$emit('afterChartExport');
          }, 1000);
        }, 1500);
      });

      cov_2b14ihjwul.s[37]++;

      if (scope.exportWithRightClick) {
        cov_2b14ihjwul.b[12][0]++;
        cov_2b14ihjwul.s[38]++;

        element.bind('contextmenu', function (event) {
          cov_2b14ihjwul.f[8]++;
          cov_2b14ihjwul.s[39]++;

          event.preventDefault();cov_2b14ihjwul.s[40]++;

          scope.chart.export('PNG', (cov_2b14ihjwul.b[13][0]++, scope.params.title) || (cov_2b14ihjwul.b[13][1]++, 'chart'));
        });
      } else {
        cov_2b14ihjwul.b[12][1]++;
      }
    }
  };
});